/* eslint-disable react-refresh/only-export-components */
import { lazy } from "react";
import { IRoute } from "./types";

const NotFound = lazy(() => import("pages/exceptions/NotFound"));
const PaymentTemplatePage = lazy(() => import("pages/dashboard/finance/payment_template"));
const InvoicePage = lazy(() => import("pages/dashboard/finance/invoice"));
const InvoiceDetailPage = lazy(() => import("pages/dashboard/finance/invoice/details"));
const Home = lazy(() => import("pages/dashboard/home"));
const Admins = lazy(() => import("pages/dashboard/admins"));
const OrgHelps = lazy(() => import("pages/dashboard/org_help"));
const Customers = lazy(() => import("pages/dashboard/customers"));
const CustomerInfo = lazy(() => import("pages/dashboard/customers/view"));
const Organizations = lazy(() => import("pages/dashboard/organization"));
const ContactBooks = lazy(() => import("pages/dashboard/organization/contact_book"));
const OrganizationCreate = lazy(() => import("pages/dashboard/organization/create"));
const OrganizationUpdate = lazy(() => import("pages/dashboard/organization/update"));
const MenuSettings = lazy(() => import("pages/dashboard/organization/menu"));
const SuhSettings = lazy(() => import("pages/dashboard/organization/suh"));
const Buildings = lazy(() => import("pages/dashboard/building"));
const BuildingCreate = lazy(() => import("pages/dashboard/building/create"));
const BuildingUpdate = lazy(() => import("pages/dashboard/building/update"));

const Equipments = lazy(() => import("pages/dashboard/equipment"));
const EquipmentCreate = lazy(() => import("pages/dashboard/equipment/create"));
const EquipmentUpdate = lazy(() => import("pages/dashboard/equipment/update"));

const Cars = lazy(() => import("pages/dashboard/car/list"));
const Cameras = lazy(() => import("pages/dashboard/car/camera"));
const CarLogs = lazy(() => import("pages/dashboard/car/list/log"));
const CarCreate = lazy(() => import("pages/dashboard/car/list/create"));
const CarUpdate = lazy(() => import("pages/dashboard/car/list/update"));

const Payments = lazy(() => import("pages/dashboard/payment"));
const QPayInvoices = lazy(() => import("pages/dashboard/qpay"));

const Banners = lazy(() => import("pages/dashboard/banner"));
const BannerLogs = lazy(() => import("pages/dashboard/banner/log"));
const BannerCreate = lazy(() => import("pages/dashboard/banner/tabs/banners/create"));
const BannerUpdate = lazy(() => import("pages/dashboard/banner/tabs/banners/update"));

const Ownerships = lazy(() => import("pages/dashboard/owner/ownership"));
const OwnershipInfoPage = lazy(() => import("pages/dashboard/owner/ownership/view"));
const PropertiesPage = lazy(() => import("pages/dashboard/owner/property"));
const PropertyInfoPage = lazy(() => import("pages/dashboard/owner/property/view"));
const PropertyLogs = lazy(() => import("pages/dashboard/owner/property/log"));

const InquiryPage = lazy(() => import("pages/dashboard/inquiry"));
const SurveyPage = lazy(() => import("pages/dashboard/survey"));
const ParkingInvitePage = lazy(() => import("pages/dashboard/parking/invite"));
const SuspiciousLoginPage = lazy(() => import("pages/dashboard/parking/suspicious_login"));

const PostPage = lazy(() => import("pages/dashboard/post"));
const CentralizedNotifPage = lazy(() => import("pages/dashboard/centralized_notif"));

const OpenClosePage = lazy(() => import("pages/dashboard/report/open_close"));
const OpenCloseLogPage = lazy(() => import("pages/dashboard/report/open_close_log"));
const ParkingInviteReportPage = lazy(() => import("pages/dashboard/report/parking_invite"));
const PaymentPage = lazy(() => import("pages/dashboard/finance/payment"));
const PaymentHistoryPage = lazy(() => import("pages/dashboard/finance/payment_history"));
const TransactionCategoryPage = lazy(() => import("pages/dashboard/finance/transaction_category"));
const TransactionPage = lazy(() => import("pages/dashboard/finance/transaction"));
const SUHDashboardPage = lazy(() => import("pages/dashboard/finance/dashboard"));
const SUHDashboardFinancePage = lazy(() => import("pages/dashboard/suh_finance_dashboard"));
const SUHInvoiceUnpaidReportPage = lazy(() => import("pages/dashboard/report/suh_invoice_unpaid"));
const SUHFinanceReportPage = lazy(() => import("pages/dashboard/report/suh_finance_report"));
const SurveyViewPage = lazy(() => import("pages/dashboard/survey/view"));

const dashboardRoutes: IRoute[] = [
  {
    key: "suh_finance_dashboard",
    path: "suh_finance_dashboard",
    component: <SUHDashboardFinancePage />,
  },
  {
    key: "transaction/dashboard",
    path: "transaction/dashboard",
    component: <SUHDashboardPage />,
  },
  {
    key: "transaction/category",
    path: "transaction/category",
    component: <TransactionCategoryPage />,
  },
  {
    key: "transaction/income/suh",
    path: "transaction/income/suh",
    component: <PaymentPage is_paid={true} />,
  },
  {
    key: "transaction/receivable/suh",
    path: "transaction/receivable/suh",
    component: <PaymentPage is_paid={false} />,
  },
  {
    key: "transaction/income/other",
    path: "transaction/income/other",
    component: <TransactionPage transaction_type="income" />,
  },
  {
    key: "transaction/receivable/other",
    path: "transaction/receivable/other",
    component: <TransactionPage transaction_type="receivable" />,
  },
  {
    key: "transaction/expense",
    path: "transaction/expense",
    component: <TransactionPage transaction_type="expense" />,
  },
  {
    key: "transaction/payable",
    path: "transaction/payable",
    component: <TransactionPage transaction_type="payable" />,
  },
  {
    key: "finance/payment_template",
    path: "finance/payment_template",
    component: <PaymentTemplatePage />,
  },
  {
    key: "finance/invoice",
    path: "finance/invoice",
    component: <InvoicePage />,
  },
  {
    key: "finance/invoice/details",
    path: "finance/invoice/details",
    component: <InvoiceDetailPage />,
  },
  {
    key: "finance/payment",
    path: "finance/payment",
    component: <PaymentPage />,
  },
  {
    key: "finance/payment_history",
    path: "finance/payment_history",
    component: <PaymentHistoryPage />,
  },
  {
    key: "home",
    path: "home",
    component: <Home />,
  },
  {
    key: "admin",
    path: "admin",
    component: <Admins />,
  },
  {
    key: "org_help",
    path: "org_help",
    component: <OrgHelps />,
  },
  {
    key: "customer",
    path: "customer",
    component: <Customers />,
  },
  {
    key: "payment",
    path: "payment",
    component: <Payments />,
  },
  {
    key: "qpay",
    path: "qpay",
    component: <QPayInvoices />,
  },

  {
    key: "customer/view/:id",
    path: "customer/view/:id",
    component: <CustomerInfo />,
  },
  {
    key: "organization",
    path: "organization",
    component: <Organizations />,
  },
  {
    key: "organization/contact_book/:org_id",
    path: "organization/contact_book/:org_id",
    component: <ContactBooks />,
  },
  {
    key: "organization/menu/:id",
    path: "organization/menu/:id",
    component: <MenuSettings />,
  },
  {
    key: "organization/suh/:id",
    path: "organization/suh/:id",
    component: <SuhSettings />,
  },
  {
    key: "organization/create",
    path: "organization/create",
    component: <OrganizationCreate />,
  },
  {
    key: "organization/update/:id",
    path: "organization/update/:id",
    component: <OrganizationUpdate />,
  },
  {
    key: "building",
    path: "building",
    component: <Buildings />,
  },
  {
    key: "building/create",
    path: "building/create",
    component: <BuildingCreate />,
  },
  {
    key: "building/update/:id",
    path: "building/update/:id",
    component: <BuildingUpdate />,
  },
  {
    key: "equipment",
    path: "equipment",
    component: <Equipments />,
  },
  {
    key: "equipment/create",
    path: "equipment/create",
    component: <EquipmentCreate />,
  },
  {
    key: "equipment/update/:id",
    path: "equipment/update/:id",
    component: <EquipmentUpdate />,
  },
  {
    key: "car/list",
    path: "car/list",
    component: <Cars />,
  },
  {
    key: "car/camera",
    path: "car/camera",
    component: <Cameras />,
  },
  {
    key: "car/list/log",
    path: "car/list/log",
    component: <CarLogs />,
  },
  {
    key: "car/list/create",
    path: "car/list/create",
    component: <CarCreate />,
  },
  {
    key: "car/list/update/:id",
    path: "car/list/update/:id",
    component: <CarUpdate />,
  },
  {
    key: "banner",
    path: "banner",
    component: <Banners />,
  },
  {
    key: "banner/log",
    path: "banner/log",
    component: <BannerLogs />,
  },
  {
    key: "banner/create",
    path: "banner/create",
    component: <BannerCreate />,
  },
  {
    key: "banner/update/:id",
    path: "banner/update/:id",
    component: <BannerUpdate />,
  },
  {
    key: "owner/ownership",
    path: "owner/ownership",
    component: <Ownerships />,
  },
  {
    key: "owner/ownership/view/:id",
    path: "owner/ownership/view/:id",
    component: <OwnershipInfoPage />,
  },
  {
    key: "owner/property/:type",
    path: "owner/property/:type",
    component: <PropertiesPage />,
  },
  {
    key: "owner/property/:type/view/:id",
    path: "owner/property/:type/view/:id",
    component: <PropertyInfoPage />,
  },
  {
    key: "owner/property/:type/log",
    path: "owner/property/:type/log",
    component: <PropertyLogs />,
  },
  {
    key: "inquiry",
    path: "inquiry",
    component: <InquiryPage />,
  },
  {
    key: "survey",
    path: "survey",
    component: <SurveyPage />,
  },
  {
    key: "survey/view/:id",
    path: "survey/view/:id",
    component: <SurveyViewPage />,
  },
  {
    key: "post",
    path: "post",
    component: <PostPage />,
  },
  {
    key: "centralized_notif",
    path: "centralized_notif",
    component: <CentralizedNotifPage />,
  },
  {
    key: "parking/invite",
    path: "parking/invite",
    component: <ParkingInvitePage />,
  },
  {
    key: "parking/suspicious_login",
    path: "parking/suspicious_login",
    component: <SuspiciousLoginPage />,
  },
  {
    key: "report/open_close",
    path: "report/open_close",
    component: <OpenClosePage />,
  },
  {
    key: "report/open_close_log",
    path: "report/open_close_log",
    component: <OpenCloseLogPage />,
  },
  {
    key: "report/parking",
    path: "report/parking",
    component: <ParkingInviteReportPage />,
  },
  {
    key: "report/suh_invoice_unpaid",
    path: "report/suh_invoice_unpaid",
    component: <SUHInvoiceUnpaidReportPage />,
  },
  {
    key: "report/suh_finance_report",
    path: "report/suh_finance_report",
    component: <SUHFinanceReportPage />,
  },
  {
    key: "not_found",
    path: "*",
    component: <NotFound />,
  },
];
export default dashboardRoutes;
